import Cookies from 'js-cookie'

function getParameterByName(name) {
  const params = new URLSearchParams(window.location.search)
  return params.get(name) || ''
}

function getGADParameters() {
  return {
    gad_source: getParameterByName('gad_source'),
    gad_campaignid: getParameterByName('gad_campaignid'),
    gbraid: getParameterByName('gbraid'),
    gclid: getParameterByName('gclid'),
  }
}

function hasGADParameters() {
  const { gad_source, gad_campaignid, gbraid, gclid } = getGADParameters()
  return gad_source || gad_campaignid || gbraid || gclid
}

function getGADParamString() {
  const params = getGADParameters()
  return Object.entries(params)
    .filter(([_, value]) => value)
    .map(([key, value]) => `${key}=${value}`)
    .join('|') + '|'
}

export function createGADCookie() {
  if (hasGADParameters()) {
    Cookies.set('gad_tracking', getGADParamString(), { expires: 30 })
  }
}

export default function getGADParams() {
  const cookie = Cookies.get('gad_tracking')
  if (cookie) return cookie
}
